import { createSlice } from '@reduxjs/toolkit';
import { getBatchDefinitionItemCheckDepAll } from 'ducks/batch-definition-dep/operators';
import { Slices } from 'ducks/slices';
import { BatchDefinitionItemCheckDep } from 'ducks/types/store-types';

export type BatchDepDefinitionState = BatchDefinitionItemCheckDep[];

const initialState: BatchDepDefinitionState = [];

const batchDefinitionDepSlice = createSlice({
  name: Slices.BATCH_DEFINITION_DEP,
  initialState,
  reducers: {
    clearDepBatchDefinition: () => {
      return initialState;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getBatchDefinitionItemCheckDepAll.pending, () => {
        return initialState;
      })
      .addCase(getBatchDefinitionItemCheckDepAll.fulfilled, (_, { payload }) => {
        return payload;
      })
      .addCase(getBatchDefinitionItemCheckDepAll.rejected, () => {
        return initialState;
      });
  },
});

export const { clearDepBatchDefinition } = batchDefinitionDepSlice.actions;

export default batchDefinitionDepSlice.reducer;
